import { IFormation } from '@shared';

export const hasTrainingDetails = (formation: IFormation): boolean => !!formation.learningPeriod || !!formation.trainingType;
